import { ToolSchema, ToolImplementation, ToolResult } from '../tool-types';

export const addGoalCardToolMetroSchema: ToolSchema = {
  type: 'function',
  name: 'add_goal_card',
  description:
    'Display a goal card on screen as a visual anchor. Call once per identified goal during the set_goals state. ' +
    'Each goal gets its own card. Cards accumulate on screen.',
  parameters: {
    type: 'object',
    properties: {
      goalId: {
        type: 'string',
        description: 'Unique identifier for this goal (e.g. "goal_1", "goal_2")'
      },
      title: {
        type: 'string',
        description: 'Short goal label shown on the card (max ~6 words, German)'
      }
    },
    required: ['goalId', 'title'],
    additionalProperties: false
  }
};

export const addGoalCardToolMetroImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const goalId = typeof args?.goalId === 'string' ? args.goalId.trim() : '';
    const title = typeof args?.title === 'string' ? args.title.trim() : '';

    if (!goalId || !title) {
      return { success: false, error: 'goalId and title are required.' };
    }

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('metro-add-goal-card', {
          detail: { goalId, title }
        })
      );
    }

    return { success: true, data: { goalId, title } };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error in add_goal_card tool'
    };
  }
};
